module.exports = __webpack_public_path__ + "img/cooperationBG2.c33b6a2e.png";